import { CompatibilityService } from '../services/compatibilityservice';
import { ResolvePreviewSettings } from '@common/rwf';
import { RWFDocViewer } from '@common/preview/preview.shared';
import { fn } from '@common/utils';
import { IDocLink } from '@common/preview/preview.d';

export class CtrlRwfDocument {
    static Template = `<div style="height:100%; width:100%" rwf-document></div>`;
    static ShowModal($c: CompatibilityService, doc: IDocLink) {
        const dlg = $c.resolve("DialogService");
        return dlg.ShowWindow({
            windowOptions: {
                modal: true, width: "100%", height: "100%", actions: ["maximize", "close"], title: doc.Title || "Dokumentvorschau"
            },
            controller: ["$scope", ($scope: ng.IScope) => {
                let ctrl: CtrlRwfDocument;

                $scope.$on("CtrlRwfDocument", (e, _ctrl: CtrlRwfDocument) => (ctrl = _ctrl).DocViewer.SetDocLink(doc));

                $scope.$on("$destroy", () => {
                    if (ctrl) {
                        const DocViewer = ctrl.DocViewer;
                        ctrl = undefined;
                        $c.when(DocViewer.SetDocLink(undefined)).then(() =>
                            DocViewer.destroy());
                    }
                });
            }],
            template: CtrlRwfDocument.Template,
        });
    }
    static Directive = ["$injector", "CompatibilityService",
        function ($injector: ng.auto.IInjectorService, $c: CompatibilityService): ng.IDirective {
            return {
                template: '<div></div>',
                link: ($scope, element) => {
                    const $rwf = $c.resolve("Rwf")("RwfBootstrap");
                    $rwf.Resolve.then(rwf => {
                        const previewSettings = fn.clone(ResolvePreviewSettings(rwf));

                        const ctrl = $injector.instantiate(CtrlRwfDocument, { DocViewer: new RWFDocViewer(element[0], previewSettings) });
                        $scope.$emit("CtrlRwfDocument", ctrl);
                    });
                }
            };
        }];
    static $inject = ["DocViewer"];
    constructor(public readonly DocViewer: RWFDocViewer) {
    }
}
